import React from 'react';
import PropTypes from 'prop-types';

/**
 * RangeContainer component wraps its children within a form element.
 *
 * @param {Object} props - The component props.
 * @param {React.FormEventHandler<HTMLFormElement>} props.handleOnSubmit - The function to handle form submission.
 * @param {string} props.className - Additional class names for styling.
 * @param {React.ReactNode} props.children - The child elements to be rendered inside the form.
 * @returns {JSX.Element} The rendered component.
 */
export const RangeContainer = ({ handleOnSubmit, className, children }) => (
  <li>
    <form onSubmit={handleOnSubmit} className={className} method="post">
      {children}
    </form>
  </li>
);

RangeContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  handleOnSubmit: PropTypes.func.isRequired,
};
